import { CanDeactivateFn } from '@angular/router';
import { ProfilBearbeitenComponent } from './profil-bearbeiten.component';

export const canDeactivateProfilBearbeiten: CanDeactivateFn<ProfilBearbeitenComponent> = (component) =>
  !component.hasUnsavedChanges() || component.confirmDeactivate();
